import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitLead = (email, source = "newsletter") =>
  axios.post(`${API}/leads`, { email, source });

export const submitContact = (name, email, message) =>
  axios.post(`${API}/contact`, { name, email, message });

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password });

export const getAdminLeads = (token) =>
  axios.get(`${API}/admin/leads`, { headers: { Authorization: `Bearer ${token}` } });

export const getAdminContacts = (token) =>
  axios.get(`${API}/admin/contacts`, { headers: { Authorization: `Bearer ${token}` } });

export const trackBlogView = (slug) => axios.post(`${API}/blog/view`, { slug });

export const getPopularSlugs = (limit = 6) =>
  axios.get(`${API}/blog/popular`, { params: { limit } });
